import { render } from "./Landing.vue?vue&type=template&id=ea656a8e"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"

import "./Landing.vue?vue&type=style&index=0&id=ea656a8e&lang=css"
script.render = render

export default script